export const sources = {
	webp: "__VITE_ASSET__DY3bui$o__ 400w, __VITE_ASSET__DSlT2tF___ 800w, __VITE_ASSET__CroV3JF9__ 1600w, __VITE_ASSET__B4PlOy6v__ 2000w",
	jpeg: "__VITE_ASSET__AqkcNd$C__ 400w, __VITE_ASSET__BgmdDTzq__ 800w, __VITE_ASSET__CgbLHPn9__ 1600w, __VITE_ASSET__Db_YZg9W__ 2000w"
};
export const img = {
	src: "__VITE_ASSET__Db_YZg9W__",
	w: 2000,
	h: 1326
};
export default {
	sources: sources,
	img: img
};
